import styled, { css } from 'styled-components'
import { cardisTheme } from '../../theme/cardisTheme'

const printStyles = css`
  @media print {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const PageContainer = styled.div`
  width: 100%;
  height: 297mm;
  margin: 0;
  padding: 0;
  position: relative;
  overflow: hidden;
  font-family: ${cardisTheme.fonts.body};
  box-sizing: border-box;
  background-color: ${cardisTheme.colors.white};
  display: flex;
  flex-direction: column;

  @media print {
    display: flex !important;
    flex-direction: column !important;
    position: relative !important;
    height: 297mm !important;
    min-height: 297mm !important;
    max-height: 297mm !important;
    overflow: hidden !important;
    page-break-after: always !important;
    page-break-inside: avoid !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    background-color: ${cardisTheme.colors.white} !important;
  }
`

export const ContentArea = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-bottom: 0;

  @media print {
    flex: 1 !important;
    display: flex !important;
    flex-direction: column !important;
    padding-bottom: 0 !important;
  }
`

export const FooterWrapper = styled.div`
  position: relative;
  margin-top: auto;

  @media print {
    position: relative !important;
    margin-top: auto !important;
  }
`

export const FooterPattern = styled.img<{ $height?: string }>`
  width: 100%;
  height: ${({ $height }) => $height || '80px'};
  object-fit: cover;

  @media print {
    width: 100% !important;
    height: ${({ $height }) => $height || '80px'} !important;
    object-fit: cover !important;
    ${printStyles}
  }
`

export const Footer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  padding: 16px 64px;

  @media print {
    position: absolute !important;
    bottom: 0 !important;
    padding: 16px 64px !important;
    display: flex !important;
    justify-content: flex-end !important;
  }
`

export const PageNumber = styled.span`
  font-family: ${cardisTheme.fonts.body};
  font-size: 12px;
  font-weight: 500;
  color: ${cardisTheme.colors.primary};

  @media print {
    font-size: 12px !important;
    font-weight: 500 !important;
    color: ${cardisTheme.colors.primary} !important;
    ${printStyles}
  }
`
